import { AES, lib, pad, mode } from 'crypto-js';

export function convertWordArrayToUint8Array(wordArray): Uint8Array {
  var arrayOfWords = wordArray.hasOwnProperty('words') ? wordArray.words : [];
  var length = wordArray.hasOwnProperty('sigBytes')
    ? wordArray.sigBytes
    : arrayOfWords.length * 4;
  var uInt8Array = new Uint8Array(length),
    index = 0,
    word,
    i;
  for (i = 0; i < length; i++) {
    word = arrayOfWords[i];
    uInt8Array[index++] = word >> 24;
    uInt8Array[index++] = (word >> 16) & 0xff;
    uInt8Array[index++] = (word >> 8) & 0xff;
    uInt8Array[index++] = word & 0xff;
  }
  return uInt8Array;
}

const FILE_FORMAT_VERSION = 0x01;
export const ENCRYPT_CHUNK_SIZE = 16 * 1024; // 16 KB — matches original getEncryptedFile

function encrypt_file(key: any, data: any) {
  // k = enc.Utf8.parse(enc.Base64.stringify(key))
  let iv = lib.WordArray.random(16); // Generate a random 16 bytes IV

  let encrypted = AES.encrypt(data, key, {
    iv: iv,
    padding: pad.Pkcs7,
    mode: mode.CBC
  }); // Use CBC-mode and PKCS7-padding

  let joinedData = iv.clone().concat(encrypted.ciphertext); // Concat IV and Cipher Text

  return joinedData;
}

/**
 * Encrypts `data` using AES-CBC with per-chunk random IVs.
 * Algorithm is identical to the original getEncryptedFile in file_encryption.ts
 * (encrypt_file inlined — same IV generation, same concat, same conversion).
 * Output format:
 *   [0x01]  — FILE_FORMAT_VERSION (1 byte)
 *   per chunk: [uint32BE length] [IV(16) + ciphertext]
 */
export function encryptBufferWithKey(arrayBufferData: ArrayBuffer, key: any): ArrayBuffer {
  let offset = 0;
  const binaryChunks: Buffer[] = [];
  const chunkSizeInBytes = ENCRYPT_CHUNK_SIZE; //16kb chunk size

  while (offset < arrayBufferData.byteLength) {
    const chunk = arrayBufferData.slice(offset, offset + chunkSizeInBytes);
    const wordArray = lib.WordArray.create(chunk);
    // encrypt_file returns a WordArray (IV + ciphertext) without base64 encoding
    const encryptedWordArray = encrypt_file(key, wordArray);
    const encryptedBytes = convertWordArrayToUint8Array(encryptedWordArray);
    const lengthBuf = Buffer.alloc(4);
    lengthBuf.writeUInt32BE(encryptedBytes.byteLength, 0);
    binaryChunks.push(lengthBuf, Buffer.from(encryptedBytes));
    offset += chunkSizeInBytes;
  }

  const finalResult = Buffer.concat([
    Buffer.from([FILE_FORMAT_VERSION]),
    ...binaryChunks
  ]);

  return finalResult.buffer.slice(
     finalResult.byteOffset,
     finalResult.byteOffset + finalResult.byteLength
   );
}
